export default __webpack_public_path__ + "static/media/squared-corners.f989b599.webp";